export const OPEN_CART = "OPEN_CART"
export const CLOSE_CART = "CLOSE_CART"

const initialState = {}

export default function cart(state = initialState, action) {
  switch (action.type) {
    case OPEN_CART:
      return { ...state, isVisible: true }
    case CLOSE_CART:
      return { ...state, isVisible: false }
    default:
      return state
  }
}
